import React, { useEffect, useState } from "react";
import { api } from "../scripts/api";

export default function DatabaseSettingsPage() {
  const [rows, setRows] = useState([]);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const [form, setForm] = useState({ id: "", name: "", path: "" });

  const load = async () => {
    setBusy(true);
    setMsg("");
    try {
      const { data } = await api.get("/admin/dbs");
      setRows(Array.isArray(data) ? data : []);
    } catch (e) {
      setMsg(e?.response?.data?.error || "Failed to load databases");
      setRows([]);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => { load(); }, []);

  const create = async () => {
    setBusy(true);
    setMsg("");
    try {
      await api.post("/admin/dbs", form);
      setForm({ id: "", name: "", path: "" });
      await load();
    } catch (e) {
      setMsg(e?.response?.data?.error || "Create failed");
    } finally {
      setBusy(false);
    }
  };

  const update = async (id, patch) => {
    setBusy(true);
    setMsg("");
    try {
      await api.put(`/admin/dbs/${id}`, patch);
      await load();
    } catch (e) {
      setMsg(e?.response?.data?.error || "Update failed");
    } finally {
      setBusy(false);
    }
  };

  const del = async (id) => {
    if (!window.confirm("Delete this database registry entry?")) return;
    setBusy(true);
    setMsg("");
    try {
      await api.delete(`/admin/dbs/${id}`);
      await load();
    } catch (e) {
      setMsg(e?.response?.data?.error || "Delete failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container">
      <div className="row" style={{ justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <h2 style={{ margin: 0, fontWeight: 900 }}>Database Settings</h2>
        <button className="btn-outline" onClick={load} disabled={busy}>Refresh</button>
      </div>

      {msg ? <div className="muted" style={{ marginTop: 10 }}>{msg}</div> : null}

      <div className="card" style={{ marginTop: 12 }}>
        <div style={{ fontWeight: 900, marginBottom: 10 }}>Register DB</div>
        <div className="muted" style={{ marginBottom: 10 }}>
          Path can be absolute, or relative to <code>backend/</code> (example: <code>inventory.db</code>)
        </div>

        <div className="row" style={{ gap: 10, flexWrap: "wrap" }}>
          <input className="input" placeholder="id (X-DB value)" value={form.id}
            onChange={(e) => setForm({ ...form, id: e.target.value })} />
          <input className="input" placeholder="name" value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <input className="input" placeholder="path" value={form.path}
            onChange={(e) => setForm({ ...form, path: e.target.value })} style={{ minWidth: 320 }} />
          <button className="btn" onClick={create} disabled={busy || !form.id || !form.path}>Add</button>
        </div>
      </div>

      <div className="card" style={{ marginTop: 12 }}>
        <div style={{ fontWeight: 900, marginBottom: 10 }}>Registered databases</div>

        <div style={{ display: "grid", gap: 10 }}>
          {rows.map((d) => (
            <div key={d.id} className="card" style={{ background: "rgba(255,255,255,0.02)" }}>
              <div style={{ fontWeight: 900 }}>{d.name || d.id}</div>
              <div className="muted" style={{ marginTop: 6 }}>
                id=<code>{d.id}</code> • path=<code>{d.path}</code>
              </div>

              <div className="row" style={{ gap: 8, marginTop: 10, flexWrap: "wrap" }}>
                <button className="btn-outline" disabled={busy}
                  onClick={() => {
                    const name = window.prompt("New name:", d.name || d.id);
                    if (name == null) return;
                    update(d.id, { name });
                  }}>
                  Rename
                </button>
                <button className="btn-outline" disabled={busy}
                  onClick={() => {
                    const path = window.prompt("New path (absolute or backend-relative):", d.path);
                    if (path == null) return;
                    update(d.id, { path });
                  }}>
                  Edit Path
                </button>
                <button className="btn-outline" disabled={busy} onClick={() => del(d.id)}>
                  Delete
                </button>
                <button className="btn-outline" disabled={busy}
                  onClick={() => {
                    localStorage.setItem("active_db", d.id);
                    window.location.reload();
                  }}>
                  Set Active (X-DB)
                </button>
              </div>
            </div>
          ))}
          {!busy && rows.length === 0 ? <div className="muted">No databases registered.</div> : null}
        </div>
      </div>
    </div>
  );
}
